// Filename - components/landing/InnovationFirst.js

import React  from "react";
import { Container, Row, Col} from "react-bootstrap";
import { Link } from "react-router-dom";


export default function InnovationFirst (){


    return (
      <Container fluid className="p-5" style={{backgroundColor: '#eef6fe'}}>
         <Row className="mx-3 mt-3">
            <h3 className="display-4"><em>Innovation First</em> Methodology </h3>
            <p className="lead"> A first principles approach that starts with the true purpose of any modern organization - to <em>innovate</em>. </p>
         </Row>
         <Row className="mx-3">
            <Col className="col-12 col-md-4 text-left">
            </Col>
            <Col className="col-12 col-md-4 text-left">
            </Col>
            <Col className="col-12 col-md-4 text-left">
            </Col>
         </Row>
         
         <Row className="mx-3">
            <Col className="col-12 col-md-8 text-left">
   
               <p> Our unique approach leverages individual cognitive-emotional skills, swarm behaviours and organizational support to produce <em> transformational creativity</em>. Creativity that goes beyond incremental improvements to <strong> disrupting </strong> industries.</p>
               <p> And it requires a different approach to management from building the right skills (like <Link to="https://edcircuit.com/how-to-boost-your-creativity-by-combining-ideas/" target="_blank" style={{color:'#c87137'}}> associative </Link> or <Link to="https://edcircuit.com/challenging-assumptions-for-more-creative-insights-education/" target="_blank" style={{color:'#c87137'}}> reverse </Link> thinking) to handling group interactions and incentives. <em>Want to turbocharge your team's creativity? </em></p>
              
               <Row>
                  <Col className="col-12 col-md-6">
                     <p className="lead"> <Link to="/docs/hackingCreativity/1nnovationFirstWhitePaper.pdf" target="_blank">Download White Paper &raquo;</Link> </p>
                  </Col>
                  <Col className="col-12 col-md-6">
                     <p> <Link className="btn text-white" style={{backgroundColor:'#c87137'}} to="mailto:hello@mindantix.com" role="button">Email us to learn more &raquo;</Link></p>
                  </Col>
               </Row>
            </Col>
            <Col className="col-12 col-md-4 text-center">
               <h1 className="display-2" style={{color:'#c87137'}}> &ge; 2X </h1>
               <p className="font-italic"> (increase in creativity with our approach) </p>
            </Col>
         </Row>

      </Container>
    )

}
